import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "MedicalWebPage",
   "@id": "https://www.futurefamilyai.com/monitoring/when-to-call-doctor-blood-pressure-pregnancy/#webpage",
   "url": "https://www.futurefamilyai.com/monitoring/when-to-call-doctor-blood-pressure-pregnancy/",
   "name": "When to Call Your Doctor About BP | FutureFamilyAI",
   "description": "Have a written plan before an elevated reading. Severe-range readings (160/110+) need urgent care. Know what to do and when.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Kulsoom Baloch, MBBS, MPH",
    "jobTitle": "Clinical Protocol Author, FutureFamilyAI",
    "url": "https://www.futurefamilyai.com/about/#kulsoom-baloch",
    "worksFor": {
     "@type": "Organization",
     "name": "FutureFamilyAI"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Blood Pressure During Pregnancy",
     "item": "https://www.futurefamilyai.com/monitoring/blood-pressure-pregnancy/"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "When to Call Your Doctor About BP",
     "item": "https://www.futurefamilyai.com/monitoring/when-to-call-doctor-blood-pressure-pregnancy/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "At what blood pressure should a pregnant woman go to the hospital?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Readings of 160/110 or higher, or severe symptoms, need urgent evaluation. Follow your clinician's plan."
     }
    },
    {
     "@type": "Question",
     "name": "Should I retake a high blood pressure reading?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Usually yes — rest a few minutes and repeat. If it stays high or you have symptoms, call."
     }
    },
    {
     "@type": "Question",
     "name": "Is 140/90 an emergency in pregnancy?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "It's considered elevated and warrants contacting your clinician. It becomes urgent at 160/110 or with severe symptoms."
     }
    },
    {
     "@type": "Question",
     "name": "What should I say when I call?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Your readings, times, symptoms, weeks of pregnancy and medications."
     }
    },
    {
     "@type": "Question",
     "name": "Will FutureFamilyAI call my doctor for me?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. Orange and Red are reviewed by a care team, but you should always contact your provider directly."
     }
    },
    {
     "@type": "Question",
     "name": "What if my doctor's office is closed?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Use your practice's after-hours line or go to labor and delivery/ER. Call 911 for severe symptoms."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function MonitoringWhenToCallDoctorBloodPressurePregnancyPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <Link to="/monitoring/blood-pressure-pregnancy">
                Blood Pressure During Pregnancy
              </Link>
              <span>›</span>
              <span>When to Call Your Doctor About BP</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                Call your doctor when a pregnancy blood pressure reading is
                above the threshold in your written care plan — often 140/90 —
                and get urgent care for 160/110 or higher or for severe symptoms
                such as headache, vision changes, chest pain or trouble
                breathing.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Expecting mothers</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      In pregnancy, a blood pressure of 160 systolic or 110
                      diastolic or higher is in the severe range and needs
                      urgent evaluation. (ACOG Practice Bulletin No. 222, 2020)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Your plan, built into your status · Clear next step every
                      time · Readings ready to share on the call
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">BLOOD PRESSURE GUIDE</span>
            <h1>When to Call Your Doctor About Blood Pressure in Pregnancy</h1>
            <p className="ffh-answer speakable-content">
              Call your doctor when a pregnancy blood pressure reading is above
              the threshold in your written care plan — often 140/90 — and get
              urgent care for 160/110 or higher or for severe symptoms such as
              headache, vision changes, chest pain or trouble breathing.
              Don&apos;t wait for an app alert. FutureFamilyAI helps you follow
              your clinician&apos;s plan with clear color guidance. Build your
              action plan.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#kulsoom-baloch">
                    Dr. Kulsoom Baloch, MBBS, MPH
                  </Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <a className="ffh-btn ffh-primary" href={APP_STORE_URL}>
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Download on the App Store
              </a>
              <Link className="ffh-btn ffh-ghost" to="/contact-us?type=member">
                Request Free Pilot Access
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Pregnant woman calling her doctor about a high blood pressure reading"
              >
                <figcaption>
                  <b>Photo slot</b> · Pregnant woman at home on a phone call,
                  holding a notebook with her readings (not legible), composed
                  and proactive. No text overlay.
                  <br />
                  <b>Alt:</b> Pregnant woman calling her doctor about a high
                  blood pressure reading
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    In pregnancy, a blood pressure of 160 systolic or 110
                    diastolic or higher is in the severe range and needs urgent
                    evaluation.
                    <cite>
                      Source:{" "}
                      <a href="https://www.acog.org/clinical/clinical-guidance/practice-bulletin/articles/2020/06/gestational-hypertension-and-preeclampsia">
                        ACOG Practice Bulletin No. 222, 2020
                      </a>
                    </cite>
                  </li>
                  <li>
                    Hypertensive disorders were present in about 1 in 7 U.S.
                    delivery hospitalizations (2017–2019).
                    <cite>
                      Source:{" "}
                      <a href="https://www.cdc.gov/mmwr/volumes/71/wr/mm7117a1.htm">
                        CDC, MMWR 2022
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>Ask your clinician for a written plan</h2>
                <ul>
                  <li>Your personal thresholds</li>
                  <li>How often to repeat a high reading</li>
                  <li>Who to call during and after hours</li>
                  <li>When to go to labor and delivery or the ER</li>
                </ul>
              </section>
              <section id="s2">
                <h2>Urgent: don&apos;t wait</h2>
                <p>
                  A reading of 160 systolic or 110 diastolic or higher, or
                  severe symptoms, needs urgent assessment even if you feel
                  fine.
                </p>
              </section>
              <div className="ffh-inline-cta">
                <p>Free pilot enrollment is open through December 31, 2026.</p>
                <a className="ffh-btn ffh-primary ffh-sm" href={APP_STORE_URL}>
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                  Download on the App Store
                </a>
              </div>
              <section id="s3">
                <h2>How FutureFamilyAI supports your plan</h2>
                <p>
                  Your status reflects your clinician&apos;s thresholds, and Red
                  always tells you to contact your provider now. Readings and
                  symptoms are ready to share during the call.
                </p>
              </section>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>
                      At what blood pressure should a pregnant woman go to the
                      hospital?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Readings of 160/110 or higher, or severe symptoms, need
                        urgent evaluation. Follow your clinician&apos;s plan.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Should I retake a high blood pressure reading?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Usually yes — rest a few minutes and repeat. If it stays
                        high or you have symptoms, call.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Is 140/90 an emergency in pregnancy?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        It&apos;s considered elevated and warrants contacting
                        your clinician. It becomes urgent at 160/110 or with
                        severe symptoms.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>What should I say when I call?</summary>
                    <div className="ffh-ans">
                      <p>
                        Your readings, times, symptoms, weeks of pregnancy and
                        medications.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Will FutureFamilyAI call my doctor for me?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. Orange and Red are reviewed by a care team, but you
                        should always contact your provider directly.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      What if my doctor&apos;s office is closed?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        Use your practice&apos;s after-hours line or go to labor
                        and delivery/ER. Call 911 for severe symptoms.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <a className="ffh-btn ffh-primary" href={APP_STORE_URL}>
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                        fill="currentColor"
                        stroke="none"
                      />
                    </svg>
                    Download on the App Store
                  </a>
                  <Link
                    className="ffh-btn ffh-ghost"
                    to="/contact-us?type=member"
                  >
                    Request Free Pilot Access
                  </Link>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">KB</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Kulsoom Baloch, MBBS, MPH</h3>
                  <p>
                    Clinical Protocol Author, FutureFamilyAI. Dr. Kulsoom
                    Baloch, MBBS, MPH, is the clinical protocol author for
                    FutureFamilyAI and a published researcher in reproductive
                    and maternal health. She developed the app&apos;s monitoring
                    protocol using ACOG, SMFM, ISSHP and AHA guidance.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/monitoring/blood-pressure-pregnancy">
                    Blood Pressure During Pregnancy →
                  </Link>
                  <Link to="/monitoring/gestational-hypertension-symptoms">
                    Gestational Hypertension Symptoms →
                  </Link>
                  <Link to="/monitoring/preeclampsia-warning-signs">
                    Preeclampsia Warning Signs →
                  </Link>
                  <Link to="/monitoring/home-blood-pressure-cuff-pregnancy">
                    Home Blood Pressure Cuffs →
                  </Link>
                  <Link to="/monitoring/blood-pressure-chart-pregnancy-trimester">
                    Blood Pressure Chart by Trimester →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">Ask your clinician for a written plan</a>
                  </li>
                  <li>
                    <a href="#s2">Urgent: don&apos;t wait</a>
                  </li>
                  <li>
                    <a href="#s3">How FutureFamilyAI supports your plan</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Join the free pilot</b>
                <span>No subscription fee through Dec 31, 2026.</span>
                <a className="ffh-btn ffh-primary ffh-sm" href={APP_STORE_URL}>
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                  Download on the App Store
                </a>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
